import { verifier as decisionManagerVerifier } from './decisionManager.js';

export const requirements = {};

export const verifier = () => {
  return decisionManagerVerifier();
};
